import { Button, Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import {
  FGCustomPanel,
  FGListen,
  FGTextInput,
  FieldGroup,
  FieldSet,
  IDataTableColumn,
  useGridState,
} from "nsitools-react";
import * as React from "react";

import { DogBroodRequestsTransientDto, DogBroodRequestTransientOwnerGridDto, EPlatform } from "../../../../api";
import { CustomDataTable, DeleteButton } from "../../../../components";
import { useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { PuppyPersonInformation } from "./PuppyPersonInformation";

export interface IPuppyOwnersProps {
  puppy: DogBroodRequestsTransientDto;
  index: number;
  platform: EPlatform;
  readonly: boolean;
  onOwnersChanged: (data: DogBroodRequestTransientOwnerGridDto[]) => void;
  isError: () => boolean;
  tooSmall: boolean;
}

export const PuppyOwners: React.FunctionComponent<IPuppyOwnersProps> = ({
  puppy,
  index,
  platform = EPlatform.CARE4DOGS,
  readonly,
  onOwnersChanged,
  isError,
  tooSmall,
}) => {
  const { t } = useTl();

  const [email, setEmail] = React.useState<string>(null);
  const [ownerEmailLoading, setOwnerEmailLoading] = React.useState<boolean>(false);
  const [owners, setOwners] = React.useState(puppy.owners);

  const tableState = useGridState<any>({
    serverMode: false,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
  });

  const { setData } = tableState;

  React.useEffect(() => {
    setData(owners);
  }, [setData, owners]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: DogBroodRequestTransientOwnerGridDto) =>
          !readonly && (
            <DeleteButton
              minimal={true}
              secured={false}
              onDelete={() => {
                const newOwners = owners.filter((e) => e !== row);
                setOwners(newOwners);
                onOwnersChanged(newOwners);
              }}
            />
          ),
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Name),
        fieldName: "computedName",
        render: (row: DogBroodRequestTransientOwnerGridDto) => row.computedName,
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Email),
        fieldName: "email",
        render: (row: DogBroodRequestTransientOwnerGridDto) => row.email,
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Address),
        fieldName: "address",
        render: (row: DogBroodRequestTransientOwnerGridDto) => row.address,
      },
    ],
    [onOwnersChanged, owners, readonly, t]
  );

  React.useEffect(() => {
    console.log("pupppyOwnerIserror", isError());
  }, [isError]);
  const [debouncedEmailState, setdebouncedEmailState] = React.useState(null);
  return (
    <>
      <FGListen
        field={`${platform === EPlatform.PORTAL ? "dogBroodRequestGetDto." : ""}puppies[${index}].puppyOwnerEmail`}
        onChanged={(value) => {
          const regexp = /(.*)[@]{1}(.*)[.]{1}([a-z]*)/g;
          const matching = regexp.test(value);
          if (matching) {
            setEmail(value);
          }
        }}
      />
      <FieldGroup columns={tooSmall ? 1 : 2}>
        {!readonly && (
          <FGTextInput
            label={t(ETLCodes.OwnerEmailAddress)}
            name={`${platform === EPlatform.PORTAL ? "dogBroodRequestGetDto." : ""}puppies[${index}].puppyOwnerEmail`}
            readonly={puppy.deceased}
            rightElement={<Button icon={IconNames.SEARCH} minimal={false} disabled loading={ownerEmailLoading} />}
            onEnterPress={() => setdebouncedEmailState(email)}
          />
        )}
        <FGCustomPanel>
          {(ctx) =>
            platform === EPlatform.PORTAL &&
            ctx.formik.values.dogBroodRequestGetDto.puppies[index].owners.length > 0 && (
              <div style={{ color: "#35a1e3" }}>{t(ETLCodes.AnotherOwnerToAddPortalMessage)}</div>
            )
          }
        </FGCustomPanel>
      </FieldGroup>
      <FieldGroup columns={2}>
        <PuppyPersonInformation
          debouncedEmailState={debouncedEmailState}
          setdebouncedEmailState={setdebouncedEmailState}
          newEmail={email}
          puppyIndex={index}
          platform={platform}
          peopleLoading={(oeLoading) => setOwnerEmailLoading(oeLoading)}
          addOwner={(owner) => {
            console.log("new owner", owner);
            const newOwners = [...owners, owner];
            console.log("list", newOwners);
            setOwners(newOwners);
            onOwnersChanged(newOwners);
          }}
          owners={owners}
        />
      </FieldGroup>
      <FieldSet title={t(ETLCodes.Owners)}>
        <CustomDataTable tableState={tableState} loading={false} columns={columns} />
        <div style={{ marginBottom: "2rem", color: "red" }}>
          {" "}
          {isError() ? (
            <>
              <Icon color="red" icon="warning-sign" style={{ marginRight: "0.5rem" }} />
              {t(ETLCodes.PuppyInformationIncomplete)}
            </>
          ) : null}
        </div>
      </FieldSet>
    </>
  );
};
